import apiBaseState from "~/constants/apiBaseState";

const getState = () => {
    return {
        getMentionsListState: apiBaseState(),
        getMentionState: apiBaseState(),
        createMentionState: apiBaseState(),
        updateMentionState: apiBaseState(),
        deleteMentionState: apiBaseState(),
        getMentionsAvailableState: apiBaseState(),
        getUsersForMentionState: apiBaseState(),
    };
};

export const state = () => (getState());

export const mutations = {
    RESET_STORE(state) {
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    SET_GET_MENTIONS(state, payload) {
        state.getMentionsListState = payload;
    },
    SET_GET_MENTION(state, payload) {
        state.getMentionState = payload;
    },
    SET_CREATE_MENTION(state, payload) {
        state.createMentionState = payload;
    },
    SET_GET_USERS_FOR_MENTION(state, payload) {
        state.getUsersForMentionState = payload;
    },
    PUSH_NEW_MENTION(state, payload) {
        if (state.getMentionsListState.data) {
            state.getMentionsListState.data.push(payload);
        }
    },
    UNSHIFT_NEW_MENTION(state, payload) {
        if (state.getMentionsListState.data) {
            state.getMentionsListState.data.unshift(payload);
        }
    },
    SET_UPDATE_MENTION(state, payload) {
        state.updateMentionState = payload;
        if (state.getMentionsListState.data) {
            const index = state.getMentionsListState.data.findIndex(mention => mention.id === payload.id);
            if (index !== -1) {
                state.getMentionsListState.data.splice(index, 1, payload);
            }
        }
    },
    SET_DELETE_MENTION(state, payload) {
        state.deleteMentionState = payload;
    },
    DELETE_MENTION_FROM_LIST(state, id) {
        if (state.getMentionsListState.data) {
            state.getMentionsListState.data = state.getMentionsListState.data.filter(mention => mention.id !== id);
        }
    },
    SET_GET_MENTIONS_AVAILABLE(state, payload) { // New mutation for getMentionsAvailable
        state.getMentionsAvailableState = payload;
    }
};

export const actions = {
    async GET_MENTIONS({ commit }, { accountSlug, projectSlug, ...params }) {
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions`;
        const whyApiResponse = await this.$whyApi.get({
            url,
            params,
            mutation: "mentions/SET_GET_MENTIONS",
            errorMessage: "Error getting mentions list",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async GET_MENTION({ commit }, { accountSlug, projectSlug, id }) {
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions/${id}`;
        const whyApiResponse = await this.$whyApi.get({
            url,
            mutation: "mentions/SET_GET_MENTION",
            errorMessage: "Error getting mention",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async CREATE_MENTION({ commit }, { accountSlug, projectSlug, ...payload }) {
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions`;
        const whyApiResponse = await this.$whyApi.post({
            url,
            data: payload,
            mutation: "mentions/SET_CREATE_MENTION",
            errorMessage: "Error creating mention",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async UPDATE_MENTION({ commit }, { accountSlug, projectSlug, id, ...payload }) {
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions/${id}`;
        const whyApiResponse = await this.$whyApi.post({
            url,
            data: payload,
            mutation: "mentions/SET_UPDATE_MENTION",
            errorMessage: "Error updating mention",
            notify: this.$notify
        });
        commit('SET_UPDATE_MENTION', whyApiResponse.data);
        return whyApiResponse;
    },
    async DELETE_MENTION({ commit }, { accountSlug, projectSlug, id }) {
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions/${id}`;
        const whyApiResponse = await this.$whyApi.delete({
            url,
            mutation: "mentions/SET_DELETE_MENTION",
            errorMessage: "Error deleting mention",
            notify: this.$notify
        });
        commit('DELETE_MENTION_FROM_LIST', id);
        return whyApiResponse;
    },
    async GET_MENTIONS_AVAILABLE({ commit }, { accountSlug, projectSlug, ...params }) { // New action for getMentionsAvailable
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions/list`;
        const whyApiResponse = await this.$whyApi.get({
            url,
            params,
            mutation: "mentions/SET_GET_MENTIONS_AVAILABLE",
            errorMessage: "Error getting available mentions",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async GET_USERS_FOR_MENTION({ commit }, { accountSlug, projectSlug, mentionId }) { // New action for getMentionsAvailable
        const url = `/accounts/${accountSlug}/${projectSlug}/mentions/${mentionId}/users`;
        const whyApiResponse = await this.$whyApi.get({
            url,
            mutation: "mentions/SET_GET_USERS_FOR_MENTION",
            errorMessage: "Error getting users for mention",
            notify: this.$notify
        });
        return whyApiResponse;
    },
};
